import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { forkJoin } from 'rxjs';
import { EDustLoadType } from 'src/app/domain/enums/dust-load-type';
import { EMasterDataType } from 'src/app/domain/enums/master-data-type';
import { EMPCEType } from 'src/app/domain/enums/mpce-type';
import { ESubSection } from 'src/app/domain/enums/subsection';
import { EVentilationGlobaleType } from 'src/app/domain/enums/ventilation-global-type';
import { Process } from 'src/app/domain/process';
import { MasterDataService } from 'src/app/services/master-data.service';
import { StringConverter } from '../string-converter';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import * as _ from 'lodash';
import { StringTool } from '../../mapping/string.tool';

@Component({
    selector: 'app-process-conformite-box',
    templateUrl: './process-conformite-box.html',
    styleUrls: ['./process-conformite-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProcessConformiteBoxDialog implements OnInit {

    public SubSectionList: string[] = Object.values(ESubSection)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getSubSectionName(x));

    public DustLoadTypeList: string[] = Object.values(EDustLoadType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getDustLoadTypeName(x));

    public MPCEList: string[] = Object.values(EMPCEType)
        .filter(x => isNaN(Number(x)))
        .map((x: any) => x);

    public VentilationGlobaleList: string[] = Object.values(EVentilationGlobaleType)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getVentilationGlobaleTypeName(x));

    public SelectedMPCEList: string[] = [];
    public ScolaMaterialList: string[] = [];
    public CatchmentList: string[] = [];
    public HumidificationList: string[] = [];
    public HumidityWorkList: string[] = [];
    public ScolaTechniqueList: string[] = [];

    public DustLevel: string[] = [];
    public Model!: Process;
    public VolumeAirString: string = '';

    constructor(
        private masterDataService: MasterDataService,
        public dialogRef: MatDialogRef<ProcessConformiteBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: Process) {

        if (data) {
            this.Model = Object.assign({}, data)
            this.retrieveMasterData();
            this.SelectedMPCEList = this.Model.EnvCollectiveMeansOfPreventionList.map(x => x.Name);
            if (this.Model.VolumeRenouvellementAir)
                this.VolumeAirString = this.Model.VolumeRenouvellementAir.toString().replace('.', ',');
        }
    }

    ngOnInit() { }

    retrieveMasterData() {
        forkJoin([
            this.masterDataService.getMasterDataByType(EMasterDataType.ScolaMaterial),
            this.masterDataService.getMasterDataByType(EMasterDataType.Catchment),
            this.masterDataService.getMasterDataByType(EMasterDataType.Humidification),
            this.masterDataService.getMasterDataByType(EMasterDataType.HumidityWork),
            this.masterDataService.getMasterDataByType(EMasterDataType.ScolaTechnique),
            this.masterDataService.getMasterDataByType(EMasterDataType.DustLevel)
        ]).subscribe(async ([Sm, C, H, Hw, St, dl]) => {
            this.ScolaMaterialList = Sm;
            this.CatchmentList = C;
            this.HumidificationList = H;
            this.HumidityWorkList = Hw;
            this.ScolaTechniqueList = St;
            this.DustLevel = dl;
        })
    }

    checkCharacters(event: KeyboardEvent) {
        // var regex = /^\d+([.,]\d+)?$/g
        var regex = /-|\d|[.,]|Backspace|ArrowLeft|ArrowRight/g
        let success = regex.test(event.key)
        if (!success)
            event.preventDefault()
    }

    validCharacters() {
        // var regex = /^\d+([.,]\d+)?$/g
        var regex = /^-{0,1}\d+([.,]?\d)?$/g
        let success = regex.test(this.VolumeAirString)
        if (success) {
            return true;
        }
        return false;
    }

    public compareWith(m1: string, m2: string) {
        return m1 === m2;
    }

    SelectionChanged(event: MatSelectChange) {
        this.Model.EnvCollectiveMeansOfPreventionList = [];
        event.value.forEach((x: string) =>
            this.Model.EnvCollectiveMeansOfPreventionList.push({ Name: x })
        )
    }

    isVolumeMandatory() {
        return this.Model.EnvCollectiveMeansOfPreventionList.map(x => x.Name).includes(EMPCEType[2]) || this.Model.EnvCollectiveMeansOfPreventionList.map(x => x.Name).includes(EMPCEType[3]);
    }

    canSave(): boolean {

        return !(this.Model.EnvCollectiveMeansOfPreventionList.map(x => x.Name).includes(EMPCEType[2]) || this.Model.EnvCollectiveMeansOfPreventionList.map(x => x.Name).includes(EMPCEType[3])) ||
            ((this.Model.EnvCollectiveMeansOfPreventionList.map(x => x.Name).includes(EMPCEType[2]) || this.Model.EnvCollectiveMeansOfPreventionList.map(x => x.Name).includes(EMPCEType[3]))
                && this.validCharacters());
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (StringTool.isNotNullOrEmpty(this.VolumeAirString)) {
            this.VolumeAirString = this.VolumeAirString.replace(',', '.')
            this.Model.VolumeRenouvellementAir = Number(this.VolumeAirString)
        } else {
            this.Model.VolumeRenouvellementAir = undefined;
        }

        this.dialogRef.close(this.Model);
    }
}
